export default class Alertas {
    constructor($scope,
                $routeParams,
                alertasService,
                severidadesService,
                tipoEquipoService,
                $location,
                toastr,
                $uibModal,
                proyectosService,
                objetoUbicacionService,
                tipoUbicacionesService,
                inventarioService,
                ubicacionService,
                method) {
        this.scope = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(alertasService);
                break;
            case 'view':
                this.view(alertasService, $routeParams, severidadesService, tipoEquipoService,proyectosService,
                        objetoUbicacionService, tipoUbicacionesService, inventarioService, ubicacionService);
                break;
            case 'new':
                this.create(alertasService, severidadesService, tipoEquipoService,proyectosService,
                            objetoUbicacionService, tipoUbicacionesService, inventarioService, ubicacionService);
                break;
        }
    }

    list(alertasService) {
        let self = this.scope;
        alertasService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.alertas = resp.data.message;
                this.scope.alertas.forEach(function (alerta) {
                   alerta.displayUbicacion = self.getUbicacion(alerta);
                   alerta.displayTipoEquipo = self.getTipoEquipo(alerta);
                });
            }
        });

        this.scope.getItemPage = (item) => {
            let index = this.scope.alertas.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        this.scope.getTipoEquipo = (alerta) => {
            let resp = '';
            if (alerta.asociadoA === 'tipoEquipo') {
                resp = alerta.tipo_equipo.nombre;
            } else {
                resp = "-";
            }

            return resp;
        };

        this.scope.getUbicacion = (alerta) => {
            let resp = '';
            if (alerta.asociadoA === 'ubicacion') {
                for (var el in alerta.ubicacion) {
                    if(alerta.ubicacion[el] != null && typeof alerta.ubicacion[el].nombre !== 'undefined') {
                        let element = alerta.ubicacion[el].nombre;
                        resp += element + '/ ';
                    }
                }
            } else {
                resp = "-";
            }

            return resp;
        };

        self.eliminar = this.eliminar.bind(this, alertasService);
    }

    view(alertasService, routeParams, severidadesService, tipoEquipoService,proyectosService,
            objetoUbicacionService, tipoUbicacionesService, inventarioService, ubicacionService) {
        let id = routeParams.id;
        let self = this.scope;
        self.aux = {
            selects: {}
        };

        alertasService.getById({_id: id})
            .then((resp, err) => {
                this.scope.alerta = resp.data.message;
            });

        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_equipos = resp.data.message;
            });

        severidadesService.getAll().then((resp, err) => {
            this.scope.aux.severidad = resp.data.message;
        });

        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.aux.proyectos = resp.data.message;
            }
        });

        /*objetoUbicacionService.getAll().then((resp, err) => {
            this.scope.aux.objeto_ubicaciones = resp.data.message;
        });*/
        this.scope.$watch('alerta.proyecto', (newVal, oldVal) => {
            if(typeof newVal !== 'undefined') {
                let filter = {
                    proyecto : newVal._id
                }
                objetoUbicacionService.getAll(filter)
                    .then((resp, err) => {
                        this.scope.aux.objeto_ubicaciones = resp.data.message;
                    });
            }
        });

        this.scope.$watch('alerta.objeto_ubicacion', (nuevo) => {

            if (typeof nuevo !== 'undefined' && typeof this.scope.alerta.proyecto !== 'undefined') {
                let filter = {
                    "objeto_ubicacion._id": nuevo._id
                };

                tipoUbicacionesService.getAll(filter)
                    .then((resp, err) => {
                        self.aux.tipo_ubicaciones = resp.data.message;
                        ubicaciones();

                        let filter = {
                            "tipo.indice": 50,
                            "objeto_ubicacion._id": nuevo._id,
                            "proyecto._id": self.alerta.proyecto._id
                        };

                        ubicacionService.getAll(filter).then((resp, err) => {
                            if (!err) {
                                if (resp.data.message.length == 0) {
                                    this.toastr.warning('No existen sectores disponibles para el area seleccionada!', {
                                        timeOut: 2000,
                                        closeButton: true
                                    });
                                }

                                let index = self.aux.tipo_ubicaciones[0].nombre_interno + 's';
                                self.aux.selects[index] = resp.data.message;
                            }
                        });
                    });
            } else if(typeof self.alerta !== 'undefined' && typeof self.alerta.asociadoA !== 'undefined') {
                if(self.alerta.asociadoA === 'ubicacion') {
                    this.toastr.warning('Debe seleccionar un proyecto!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
            }
        });

        var ubicaciones = () => {
            let data = this.scope.aux.tipo_ubicaciones;

            let arCollection = [];
            for (var el in data) {
                let aux = data[el];
                let str = 'alerta.ubicacion.' + aux.nombre_interno;
                if (aux.flag_equipos) {
                    arCollection.push(str);
                }
                this.scope.$watch(str, (nuevo) => {
                    if (typeof nuevo !== 'undefined' && nuevo != null &&  typeof nuevo.tipo !== 'undefined' && !nuevo.tipo.flag_equipos) {
                        let filter = {
                            "tipo.indice": nuevo.tipo.indice - 1,
                            "padre._id": nuevo._id
                        };
                        ubicacionService.getAll(filter)
                            .then((resp) => {
                                let data = resp.data.message;
                                if (data.length == 0) {
                                    this.toastr.warning('No existen sectores disponibles para el area seleccionada!', {
                                        timeOut: 2000,
                                        closeButton: true
                                    });
                                } else {
                                    let ind = data[0].tipo.nombre_interno + 's';
                                    self.aux.selects[ind] = data;
                                }
                            });
                    }

                    if (nuevo !== undefined && nuevo.tipo.flag_equipos) {
                        let ubicacion = nuevo._id;
                        let ubAux = this.scope.alerta.ubicacion;
                        let keyMin = '';
                        let indexMin = 50;

                        for (var el in ubAux) {
                            let element = ubAux[el];
                            if (element.tipo.indice < 50) {
                                keyMin = el;
                                indexMin = element.tipo.indice;
                            }
                        }

                        let proyecto = this.scope.alerta.proyecto._id;
                        let keyUbicacion = 'ubicacion.' + keyMin + '._id';

                        let filter = {
                            'tipo_equipo.sub_parte': false,
                            'proyecto._id': proyecto,
                        };
                        filter[keyUbicacion] = ubicacion;
                        // JSON.stringify(filter)
                        inventarioService.getAll(filter)
                            .then((resp, errp) => {
                                this.scope.aux.equipos = resp.data.message;
                            });
                    }
                });
            }
        };

        this.scope.inAction = false;
        this.scope.aux.save = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                let data = this.scope.alerta;

                alertasService.update(data)
                    .then((resp) => {
                        this.toastr.success('Alerta modificada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/alertas');
                    }).catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la alerta!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    create(alertasService, severidadesService, tipoEquipoService, proyectosService,
                objetoUbicacionService,tipoUbicacionesService, inventarioService, ubicacionService) {

        let self = this.scope;
        self.aux = {
            selects: {}
        };


        severidadesService.getAll()
            .then((resp) => {
                this.scope.aux.severidades = resp.data.message;
            });

        tipoEquipoService.getAll()
            .then((resp) => {
                this.scope.aux.tipo_equipos = resp.data.message;
            });

        severidadesService.getAll().then((resp, err) => {
            this.scope.aux.severidad = resp.data.message;
        });

        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.aux.proyectos = resp.data.message;
            }
        });

        /*objetoUbicacionService.getAll().then((resp, err) => {
            this.scope.aux.objeto_ubicaciones = resp.data.message;
        });*/
        this.scope.$watch('alerta.proyecto', (newVal, oldVal) => {
            if(typeof newVal !== 'undefined') {
                let filter = {
                    proyecto : newVal._id
                }
                objetoUbicacionService.getAll(filter)
                    .then((resp, err) => {
                        this.scope.aux.objeto_ubicaciones = resp.data.message;
                    });
            }
        });

        this.scope.$watch('alerta.objeto_ubicacion', (nuevo) => {

            if (typeof nuevo !== 'undefined' && typeof this.scope.alerta.proyecto !== 'undefined') {
                let filter = {
                    "objeto_ubicacion._id": nuevo._id
                };

                tipoUbicacionesService.getAll(filter)
                    .then((resp, err) => {
                        self.aux.tipo_ubicaciones = resp.data.message;
                        ubicaciones();

                        let filter = {
                            "tipo.indice": 50,
                            "objeto_ubicacion._id": nuevo._id,
                            "proyecto._id": self.alerta.proyecto._id
                        };

                        ubicacionService.getAll(filter).then((resp, err) => {
                            if (!err) {
                                if (resp.data.message.length == 0) {
                                    this.toastr.warning('No existen sectores disponibles para el area seleccionada!', {
                                        timeOut: 2000,
                                        closeButton: true
                                    });
                                }

                                let index = self.aux.tipo_ubicaciones[0].nombre_interno + 's';
                                self.aux.selects[index] = resp.data.message;
                            }
                        });
                    });
            } else if(typeof self.alerta !== 'undefined' && typeof self.alerta.asociadoA !== 'undefined') {
                if(self.alerta.asociadoA === 'ubicacion') {
                    this.toastr.warning('Debe seleccionar un proyecto!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                }
            }
        });

        var ubicaciones = () => {
            let data = this.scope.aux.tipo_ubicaciones;

            let arCollection = [];
            for (var el in data) {
                let aux = data[el];
                let str = 'alerta.ubicacion.' + aux.nombre_interno;
                if (aux.flag_equipos) {
                    arCollection.push(str);
                }
                this.scope.$watch(str, (nuevo) => {
                    if (typeof nuevo !== 'undefined' && nuevo != null &&  typeof nuevo.tipo !== 'undefined' && !nuevo.tipo.flag_equipos) {
                        let filter = {
                            "tipo.indice": nuevo.tipo.indice - 1,
                            "padre._id": nuevo._id
                        };
                        ubicacionService.getAll(filter)
                            .then((resp) => {
                                let data = resp.data.message;
                                if (data.length == 0) {
                                    this.toastr.warning('No existen sectores disponibles para el area seleccionada!', {
                                        timeOut: 2000,
                                        closeButton: true
                                    });
                                } else {
                                    let ind = data[0].tipo.nombre_interno + 's';
                                    self.aux.selects[ind] = data;
                                }
                            });
                    }

                    if (nuevo !== undefined && nuevo.tipo.flag_equipos) {
                        let ubicacion = nuevo._id;
                        let ubAux = this.scope.alerta.ubicacion;
                        let keyMin = '';
                        let indexMin = 50;

                        for (var el in ubAux) {
                            let element = ubAux[el];
                            if (element.tipo.indice < 50) {
                                keyMin = el;
                                indexMin = element.tipo.indice;
                            }
                        }

                        let proyecto = this.scope.alerta.proyecto._id;
                        let keyUbicacion = 'ubicacion.' + keyMin + '._id';

                        let filter = {
                            'tipo_equipo.sub_parte': false,
                            'proyecto._id': proyecto,
                        };
                        filter[keyUbicacion] = ubicacion;
                        // JSON.stringify(filter)
                        inventarioService.getAll(filter)
                            .then((resp, errp) => {
                                this.scope.aux.equipos = resp.data.message;
                            });
                    }
                });
            }
        };

        this.scope.inAction = false;
        this.scope.aux.save = () => {
            let data = this.scope.alerta;
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                alertasService.save(data)
                    .then((resp) => {
                        this.toastr.success('Alerta creada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/alertas');
                    }).catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear la alerta!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    eliminar(alertasService,alerta, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar alerta</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la alerta: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = alerta.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                alertasService.delete({_id: alerta._id}).then((resp) => {
                    self.scope.alertas.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Alerta eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                .catch((err) => {
                    self.inAction = false;
                    this.toastr.error('Error', 'Error al eliminar la alerta!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/alertas/alertas.js